import React, { createContext, useContext, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useIdleTimeout } from "./hooks/useIdleTimeout";

import LoginEmpleado from "./pages/LoginEmpleado";
import LoginAdmin    from "./pages/LoginAdmin";
import DashboardEmpleado from "./pages/DashboardEmpleado";
import DashboardAdmin    from "./pages/DashboardAdmin";
import EmpleadosAdmin    from "./pages/EmpleadosAdmin";
import RecibosAdmin      from "./pages/RecibosAdmin";

export const AuthContext = createContext(null);
export function useAuth() { return useContext(AuthContext); }

function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    const token = localStorage.getItem("token");
    const user  = JSON.parse(localStorage.getItem("user") || "null");
    return token && user ? { token, user } : null;
  });

  function login(token, user) {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    setAuth({ token, user });
  }
  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setAuth(null);
  }

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

function IdleGuard({ children }) {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const { showWarning, resetTimers } = useIdleTimeout(() => {
    if (auth) { logout(); navigate("/"); }
  });

  return (
    <>
      {showWarning && auth && (
        <div style={{
          position: "fixed", bottom: 24, right: 24, zIndex: 99999,
          background: "#001E5E", color: "white",
          padding: "16px 24px", borderRadius: 8,
          boxShadow: "0 4px 16px rgba(0,0,0,.3)",
          fontFamily: "Montserrat, sans-serif", fontSize: 14,
          display: "flex", alignItems: "center", gap: 16,
        }}>
          <span>Tu sesion se cerrara por inactividad en 2 minutos.</span>
          <button onClick={resetTimers} style={{
            background: "white", color: "#001E5E",
            border: "none", borderRadius: 4,
            padding: "6px 14px", fontWeight: 700,
            cursor: "pointer", fontFamily: "inherit",
          }}>Seguir conectado</button>
        </div>
      )}
      {children}
    </>
  );
}

function RequireAuth({ rol, children }) {
  const { auth } = useAuth();
  if (!auth) return <Navigate to="/" replace />;
  if (rol && auth.user.rol !== rol) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <IdleGuard>
          <Routes>
            <Route path="/" element={<LoginEmpleado />} />
            <Route path="/admin" element={<LoginAdmin />} />
            <Route path="/empleado" element={
              <RequireAuth rol="empleado"><DashboardEmpleado /></RequireAuth>
            } />
            <Route path="/admin/dashboard" element={
              <RequireAuth rol="admin"><DashboardAdmin /></RequireAuth>
            } />
            <Route path="/admin/empleados" element={
              <RequireAuth rol="admin"><EmpleadosAdmin /></RequireAuth>
            } />
            <Route path="/admin/recibos" element={
              <RequireAuth rol="admin"><RecibosAdmin /></RequireAuth>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </IdleGuard>
      </BrowserRouter>
    </AuthProvider>
  );
}
